import React from "react";

const C_V_ADDRESS = React.memo(
  ({ value }) => {
    return (
      <span
        title={value}
        className="cell_text_fast"
        style={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          lineHeight: "1.5",
          textAlign: "left",
        }}
      >
        {value || "-"}
      </span>
    );
  },
  (prevProps, nextProps) => prevProps.value === nextProps.value,
);

export default C_V_ADDRESS;
